import { jsPDF } from "jspdf";
import DateFormat from "../../dateFormater/dateFormat1";
import { detailTrainingGetLogoAMI } from "../../../config/apiSPA";

class GeneratePDF {
  constructor(option = {}) {
    this.doc = new jsPDF({
      orientation: "l",
      unit: "mm",
      format: "a4",
    });
    this.amiLogoUrl = "/generalImage-auth/amiLogo";
    this.maxList = option.maxList ?? 20;
    this.lastPageMinList = option.lastPageMinList ?? 3;
    this.takeDataPage = option.takeDataPage ?? 4;
    this.data = option.data ?? {};
    this.currentPage = 0;
    this.maxPage = 0;
  }
  async generate(data) {
    this.data = data;
    const participant = this.data.evaluation ?? [];
    const participantPerPage = participant.length > 0 ? this.calculatingParticipant(this.sortParticipants(participant)) : [[]];
    const pageNum = participantPerPage.length;
    this.maxPage = pageNum;
    await this.masterPage();
    for (let i = 0; i < pageNum; i++) {
      const partPage = participantPerPage[i];
      this.printParticipant(partPage);
      if (i >= pageNum - 1) {
        const filename = `HASIL PELATIHAN ${this.data.title.toUpperCase()} ${DateFormat(this.data.date)}`;
        this.doc.save(filename);
      } else {
        await this.newPage();
      }
    }
  }
  calculatingParticipant(data) {
    const maxPerPage = this.maxList;
    let pages = [];

    // 1. Bagi menjadi halaman 10 item
    for (let i = 0; i < data.length; i += maxPerPage) {
      pages.push(data.slice(i, i + maxPerPage));
    }

    // 2. Jika ada lebih dari 1 halaman, cek halaman terakhir
    if (pages.length > 1) {
      const lastPage = pages[pages.length - 1];

      // Jika halaman terakhir kurang dari 3 data
      if (lastPage.length < this.lastPageMinList) {
        const prevPage = pages[pages.length - 2];

        // Ambil 4 data dari halaman sebelumnya
        const takeCount = this.takeDataPage;

        // Kalau prevPage kurang dari 4, ambil sebanyak yang ada
        const realTake = Math.min(prevPage.length, takeCount);

        const moved = prevPage.splice(prevPage.length - realTake, realTake);

        // Gabungkan data pindahan dengan data terakhir
        pages[pages.length - 1] = [...moved, ...lastPage];
      }
    }

    return pages;
  }

  sortParticipants(participants = []) {
    return participants.sort((a, b) => Number(b.postTest) - Number(a.postTest));
  }

  /**
   * @typedef {Object} TrainingInfoData
   * @property {string} [trCode]
   * @property {string} [trTitle]
   * @property {string} [duration]
   * @property {string} [trDate]
   * @property {string} [assDate]
   * @property {string} [location]
   * @property {string} [instructor]
   */

  /**
   * @param {TrainingInfoData} data
   */
  trainingInfo(data = {}) {
    const trCode = data.trCode ?? "-";
    const trTitle = data.trTitle ?? "-";
    const duration = data.duration ?? "-";
    const trDate = data.trDate ?? "-";
    const assDate = data.assDate ?? "-";
    const location = data.location ?? "-";
    const instructor = data.instructor ?? "-";
    this.doc.setFontSize(10);
    this.doc.setFont("Helvetica", "normal");
    this.doc.setTextColor(0, 0, 0);
    //Kode Pelatihan", 11.6, 33
    this.doc.text(trCode, 62, 33);
    //Nama Pelatihan", 11.6, 37.2
    this.doc.text(trTitle, 62, 37.2);
    //Durasi", 11.6, 41.5
    this.doc.text(duration, 62, 41.5);
    //Tanggal Pelatihan", 11.6, 45.7
    this.doc.text(DateFormat(trDate), 62, 45.7);
    //Tanggal Assessment", 11.6, 50
    this.doc.text(DateFormat(assDate), 62, 50);
    //Lokasi", 11.6, 54.2
    this.doc.text(location, 62, 54.2);
    //Nama Instruktur
    this.doc.text(instructor, 62, 58.4);
    //Nama ttd instructor
    this.doc.text(instructor, 192, 190.3);
    //Tanggal ttd
    this.doc.text(DateFormat(trDate), 195, 194.3);
  }
  /**
   * @typedef {Object} ParticipantItem
   * @property {string} minepermitNumber
   * @property {string} participantName
   * @property {string} company
   * @property {string} position
   * @property {float} preTest
   * @property {float} practiceTest
   * @property {float} postTest
   * @property {string} result
   * @property {string} result
   */

  /**
   * @param {ParticipantItem[]} data
   */

  printParticipant(data = []) {
    this.doc.setFont("Helvetica", "normal");
    this.doc.setFontSize(6);

    const totalList = this.maxList;
    const gapY = 4.4;
    let startY = 80.9;

    // Pastikan data selalu berupa array
    const participants = Array.isArray(data) ? data : [];

    for (let i = 0; i < totalList; i++) {
      const val = participants[i] ?? {};

      const result = String(val.result ?? "").toUpperCase();
      const isNotPass = result !== "" && result !== "PASS";

      this.doc.setTextColor(0, 0, 0);

      this.doc.text(String(i + 1), 15, startY, "center");
      this.doc.text(String(val.minepermitNumber ?? "-"), 20, startY);

      if (isNotPass) this.doc.setTextColor(255, 0, 0);
      this.doc.text(String(val.participantName ?? "-"), 53, startY);

      this.doc.text(String(val.company ?? "-"), 116.6, startY, "center");

      this.doc.setTextColor(0, 0, 0);

      this.doc.text(String(val.position ?? "-"), 175, startY, "center");
      this.doc.text(String(val.preTest ?? "-"), 222, startY, "center");
      this.doc.text(String(val.practiceTest ?? "-"), 238, startY, "center");

      if (isNotPass) this.doc.setTextColor(255, 0, 0);

      this.doc.text(String(val.postTest ?? "-"), 249, startY, "center");
      this.doc.text(result ? (result === "PASS" ? "CO" : "NYC") : "-", 260, startY, "center");

      this.doc.setTextColor(0, 0, 0);
      this.doc.text(String(val.remark ?? "-"), 275.2, startY, "center");

      startY += gapY;
    }
  }
  staticText() {
    this.doc.setFont("Helvetica", "bold");
    this.doc.setFontSize(13);
    this.doc.text("FORM PENILAIAN HASIL PELATIHAN", 148.5, 18.7, "center");
    this.doc.setFontSize(10);
    this.doc.setFont("Helvetica");
    this.doc.text("No. Document ", 224.9, 13.9);
    this.doc.text(": F-MAC-IMS-16-006 ", 248, 13.9);
    this.doc.text("No. Revisi ", 224.9, 13.9 + 5.7);
    this.doc.text(": 1.0  ", 248, 13.9 + 5.7);
    this.doc.text("Tanggal ", 224.9, 13.9 + 5.7 + 5.7);
    this.doc.text(": 01-11-2020 ", 248, 13.9 + 5.7 + 5.7);
    this.doc.text("Kode Pelatihan", 11.6, 33);
    this.doc.text(`: `, 60, 33);
    this.doc.text("Nama Pelatihan", 11.6, 37.2);
    this.doc.text(`: `, 60, 37.2);
    this.doc.text("Durasi", 11.6, 41.5);
    this.doc.text(`: `, 60, 41.5);
    this.doc.text("Tanggal Pelatihan", 11.6, 45.7);
    this.doc.text(`: `, 60, 45.7);
    this.doc.text("Tanggal Assessment", 11.6, 50);
    this.doc.text(`: `, 60, 50);
    this.doc.text("Lokasi", 11.6, 54.2);
    this.doc.text(`: `, 60, 54.2);
    this.doc.text("Nama Instruktur", 11.6, 58.4);
    this.doc.text(`: `, 60, 58.4);
    //table header
    this.doc.setFontSize(10);
    this.doc.setFont("Helvetica", "bold");
    this.doc.text("No.", 12.6, 72.7);
    this.doc.text("No Mine Permit", 22, 72.7);
    this.doc.text("Nama Karyawan", 58.2, 72.7);
    this.doc.text("Perusahaan", 104.5, 72.7);
    this.doc.text("Posisi", 170.3, 72.7);
    this.doc.text("Nilai Pelatihan", 227.1, 67.6);
    this.doc.text("Pre Test", 216.7, 72);
    this.doc.text("(*)", 221.9, 76);
    this.doc.text("PAC", 234.2, 74.1);
    this.doc.text("Hasil", 255.6, 72);
    this.doc.text("(**)", 256.9, 76);
    this.doc.text("WAC", 244.6, 74.1);
    this.doc.text("Keterangan", 265.6, 72.7);
    // --------------------
    this.doc.setFontSize(10);
    this.doc.setFont("Helvetica");
    this.doc.text("Disiapkan Oleh,", 178.4, 172.1);
    this.doc.text(`Nama : `, 178.7, 190.3);
    this.doc.text(`Tanggal : `, 178.3, 194.3);
    this.doc.text("Disetujui Oleh,", 235.4, 172.1);
    this.doc.text("Nama :", 236.2, 190.3);
    this.doc.text("Tanggal :", 235.8, 194.3);

    this.doc.text("Keterangan :", 19.1, 172);
    this.doc.text("(*) Apabila tidak tersedia/tidak dilakukan", 28.9, 177.2);
    this.doc.text("(**) CO (Competent) - Bila Nilai Pelatihan > 75", 28.9, 182.2);
    this.doc.line(94.5, 182.2, 96.5, 182.2);
    this.doc.text("(**) NYC (Not Yet Competent) - Bila Nilai Pelatihan < 75", 28.9, 187);
  }
  page(currentPage, maxPage) {
    this.doc.setFont("times", "bold");
    this.doc.setFontSize(9);
    this.doc.text("Halaman: " + currentPage + "/" + maxPage, 255, 9.5);
  }
  printTable() {
    this.doc.rect(10, 10, 277, 190);
    this.doc.line(10, 27, 287, 27);
    this.doc.line(10, 28.7, 287, 28.7);
    this.doc.line(10, 60.8, 287, 60.8);
    this.doc.line(10, 62.5, 287, 62.5);
    this.doc.line(54.7, 10, 54.7, 27);
    this.doc.line(224, 10, 224, 27);
    this.doc.setFillColor(0, 176, 80); // warna hijau
    this.doc.rect(11.6, 64, 273.8, 13.2, "F"); //header table hijau
    this.doc.rect(11.6, 64, 273.8, 101.2);

    //Horizontal content line
    const gapLine = 4.4;
    let gapStart = 77.2;
    const lineQty = 20;
    this.doc.line(11.6, gapStart, 285.4, gapStart);
    for (let index = 0; index < lineQty; index++) {
      gapStart = gapStart + gapLine;
      this.doc.line(11.6, gapStart, 285.4, gapStart);
    }
    this.doc.line(212.4, 68.7, 265.4, 68.7);
    this.doc.line(177.3, 191.2, 224, 191.2);
    this.doc.line(235.1, 191.2, 277.9, 191.2);

    //Dash line
    this.doc.setLineDashPattern([2, 1], 0);
    const gapLineDash = 4.2;
    let lineDashStartY = 34;
    const lineDashQty = 7;
    for (let i = 0; i < lineDashQty; i++) {
      this.doc.line(60, lineDashStartY, 285.4, lineDashStartY);
      lineDashStartY += gapLineDash;
    }

    //Vertical content line
    this.doc.setLineDashPattern([], 0);
    this.doc.line(18.8, 64, 18.8, 165.2);
    this.doc.line(51.2, 64, 51.2, 165.2);
    this.doc.line(96.7, 64, 96.7, 165.2);
    this.doc.line(137, 64, 137, 165.2);
    this.doc.line(212.4, 64, 212.4, 165.2);
    this.doc.line(232.4, 68.7, 232.4, 165.2);
    this.doc.line(243.4, 68.7, 243.4, 165.2);
    this.doc.line(254.4, 68.7, 254.4, 165.2);
    this.doc.line(265.4, 64, 265.4, 165.2);
  }
  footer() {
    this.doc.setFont("times", "italic");
    this.doc.setFontSize(6);
    this.doc.text(`This document was generated from ppdmaco.com at: ${new Date()} by: ${this.data.userName}`, 14, 202);
  }
  async masterPage() {
    const header = this.data ?? {};
    this.printTable();
    await this.addLogo();
    this.staticText();
    this.footer();
    this.trainingInfo({ trTitle: header.title, trCode: header.code, duration: header.duration, trDate: header.date, assDate: header.assessmentDate, location: header.location, instructor: header.instructor });
    this.currentPage++;
    this.page(this.currentPage, this.maxPage);
  }
  async newPage() {
    this.doc.addPage();
    await this.masterPage();
  }
  async addLogo() {
    try {
      const img = await this.getImage(this.amiLogoUrl);
      this.doc.addImage(img, "jpg", 18, 14, 26, 10);
    } catch (error) {
      this.doc.text("Image Error", 18, 22);
    }
  }
  getImage(url) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await detailTrainingGetLogoAMI(url);
        const base64 = res.img;
        if (!base64) {
          return reject(new Error("Response tidak mengandung field data"));
        }
        // Deteksi apakah sudah lengkap data:image/...
        const imgSrc = base64.startsWith("data:image") ? base64 : `data:image/jpeg;base64,${base64}`;
        const img = new Image();
        // img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error("Gagal memuat gambar dari Base64"));
        img.src = imgSrc;
      } catch (error) {
        reject(error);
      }
    });
  }
}

/**
 *
 * @param {{
 * duration:string,
 * instructor:string,
 * title:string,
 * code:string,
 * location:string,
 * date:string,
 * assessmentDate:string,
 * userName:string,
 * evaluation:array<{
 *  minepermitNumber:string,
 *  participantName:string,
 *  company:string,
 *  position:string,
 *  preTest:number,
 *  postTest:number,
 *  practiceTest:number,
 *  result:string,
 *  remark:string}>
 * }} data
 * @returns {Promise <boolean>}
 */
async function ReportAmiPDF(data) {
  const generate = new GeneratePDF();
  await generate.generate(data);
  return true;
}
export default ReportAmiPDF;
